import { I18n } from "react-thunk-i18nify";

import { addMinutes, format } from "date-fns";
import { da, enGB } from "date-fns/locale";

import { store } from "redux/store";

const secondsToMilliSeconds = 1000;

// NOTE: Make sure we use 24 hour format here instead of 12 hour format
export const convertToDuration = (secondsAmount, dateFormat = "mm:ss") => {
  if (!secondsAmount) return "00:00";
  const {
    i18n: { locale },
  } = store.getState();

  const selectedLocale = locale === "da-DK" ? da : enGB;

  const milliSeconds = secondsAmount * secondsToMilliSeconds;

  const d = new Date(milliSeconds);

  const dateWithoutTimezoneDiff = addMinutes(d, d.getTimezoneOffset());

  return format(dateWithoutTimezoneDiff, dateFormat, {
    locale: selectedLocale,
  });
};

export const getCallDuration = (seconds) => {
  if (seconds === 0) {
    return `0 ${I18n.t("timeUnit.sec")}`;
  }
  if (seconds < 60) {
    return convertToDuration(seconds, `s '${I18n.t("timeUnit.sec")}'`);
  }
  if (seconds > 60 && seconds < 3600) {
    return convertToDuration(
      seconds,
      `m'${I18n.t("timeUnit.m")}' s'${I18n.t("timeUnit.s")}'`
    );
  }

  return convertToDuration(
    seconds,
    `H'${I18n.t("timeUnit.hr")}' m'${I18n.t("timeUnit.m")}': s'${I18n.t(
      "timeUnit.s"
    )}'`
  );
};
